import { getLocationCategories, getLocations, getSubwayStations } from '../api';

const initialState = {
    isLoading: true,
    categories: [],
    points: [],
    features: { type: 'FeatureCollection', features: [] },
    viewedCoordinates: {
        id: null,
        coordinates: []
    }
}

export const locations = ({
    state: initialState,
    reducers: {
        setLocations(state, locales) {
            return {
                ...state,
                features: locales,
                isLoading: false
            }
        },
        setLocationCategories(state, categories) {
            return {
                ...state,
                dropdownOptions: categories.categories,
                ...categories,
                isLoading: false
            }
        },
        setBogotaLocations(state, locations) {
            return {
                ...state,
                ...locations,
                isLoading: false
            }
        },
        setLocationSelections(state, values) {
            return {
                ...state,
                categories: values,
                isLoading: false,
            }
        },
        setCoordinatesForZoom(state, coordinates) {
            return {
                ...state,
                viewedCoordinates: coordinates
            }
        }
    },
    effects: {
        async loadLocationCategories() {
            const locationsList = await getLocationCategories();
            this.setLocationCategories(locationsList);
        },
        async loadBogotaLocations() {
            const locationsList = await getLocations();
            this.setBogotaLocations(locationsList);
        },
        async loadSubwayStations(){
            const stationsList = await getSubwayStations();
            this.setLocations(stationsList);
        },
        onValueChange(values) {
            this.setLocationSelections(values);
        },
        onListingHover(coordinates) {
            this.setCoordinatesForZoom(coordinates)
        }

    }
})

